export default __webpack_public_path__ + "static/media/speech-card.766af157.jpg";